/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Hub } from '../model/hub';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class HubApiService {

    protected basePath = 'https://app-tst.pikyrent.com:33443';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Get hubs by city ID
     * Returns all hubs for a specific city. Use the pickupPointsOnly query parameter to filter only hubs that are pickup points for scheduled bookings. The content can be translated based on the &#x60;Accept-Language&#x60; header (e.g., &#x60;en&#x60;, &#x60;it&#x60;).
     * @param id City ID
     * @param pickupPointsOnly If true, returns only hubs that are pickup points for scheduled bookings
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHubsByCityId(id: number, pickupPointsOnly?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<Hub>>;
    public getHubsByCityId(id: number, pickupPointsOnly?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Hub>>>;
    public getHubsByCityId(id: number, pickupPointsOnly?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Hub>>>;
    public getHubsByCityId(id: number, pickupPointsOnly?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getHubsByCityId.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pickupPointsOnly !== undefined && pickupPointsOnly !== null) {
            queryParameters = queryParameters.set('pickupPointsOnly', <any>pickupPointsOnly);
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Hub>>('get',`${this.basePath}/hub/by-city/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
